import { imageAssets } from './content/imageAssets';

export interface Client {
  name: string;
  logoUrl: string;
  websiteUrl: string;
}

export const CARD_DURATION = 5000; // 5 seconds

export const clientsData: Client[] = [
  {
    name: 'J94 Designs',
    logoUrl: imageAssets.clientLogos.j94Designs,
    websiteUrl: 'https://www.j94design.com/'
  },
  {
    name: 'Craft Papi',
    logoUrl: imageAssets.clientLogos.craftPapi,
    websiteUrl: 'https://www.craftpapi.com/'
  },
  {
    name: 'ZamGa Transportation Services',
    logoUrl: '',
    websiteUrl: 'https://example.com/zamga'
  },
  {
    name: 'Usua Services',
    logoUrl: '',
    websiteUrl: 'https://example.com/usua'
  },
  {
    name: 'Max Cargo Transportation Services',
    logoUrl: '',
    websiteUrl: 'https://example.com/maxcargo'
  },
  {
    name: 'MDAPDC',
    logoUrl: '',
    websiteUrl: 'https://example.com/mdapdc'
  },
  {
    name: 'Paw Stuffs',
    logoUrl: imageAssets.clientLogos.pawStuffs,
    websiteUrl: 'https://pawstuffs.com/'
  },
  {
    name: 'Riverpark Dental',
    logoUrl: 'https://riverparkdental.ca/public/images/logo.png',
    websiteUrl: 'https://riverparkdental.ca'
  }
];
